var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { gutter: 10 } },
    [
      _c("el-col", { attrs: { xs: 0, sm: 6, md: 6, lg: 6, xl: 6 } }, [
        _vm._v(" "),
      ]),
      _vm._v(" "),
      _c("el-col", { attrs: { xs: 24, sm: 12, md: 12, lg: 12, xl: 12 } }, [
        _c("div", { staticStyle: { "margin-top": "35px" } }, [
          _c("div", { staticStyle: { "text-align": "center" } }, [
            _c(
              "h1",
              {
                staticStyle: {
                  "font-size": "22px",
                  "line-height": "1.4",
                  "margin-bottom": "14px",
                  "font-weight": "500",
                  "margin-left": "20px",
                },
              },
              [_vm._v(_vm._s(this.$t("questionNaire.title")))]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "contentMain",
              staticStyle: { "margin-top": "55px" },
            },
            [
              _c("p", [_vm._v(_vm._s(this.$t("questionNaire.text1")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(this.$t("questionNaire.text2")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(this.$t("questionNaire.text3")))]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(this.$t("questionNaire.text4")))]),
              _vm._v("    "),
              _c(
                "a",
                {
                  staticStyle: { color: "#409EFF" },
                  attrs: {
                    href: _vm.isCnLang
                      ? "https://www.wjx.cn/vm/reY9LKA.aspx"
                      : "https://www.wjx.cn/vm/PXs5Xlr.aspx",
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.isCnLang
                        ? "https://www.wjx.cn/vm/reY9LKA.aspx"
                        : "https://www.wjx.cn/vm/PXs5Xlr.aspx"
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(this.$t("questionNaire.text5")))]),
            ]
          ),
          _vm._v(" "),
          _vm.isCnLang
            ? _c(
                "div",
                { staticStyle: { "text-align": "left", margin: "15px" } },
                [
                  _c("img", {
                    staticStyle: { "max-width": "120px" },
                    attrs: { src: require("@/assets/img/questionNaireZh.png") },
                  }),
                ]
              )
            : _c(
                "div",
                { staticStyle: { "text-align": "left", margin: "15px" } },
                [
                  _c("img", {
                    staticStyle: { "max-width": "120px" },
                    attrs: { src: require("@/assets/img/questionNaireEn.png") },
                  }),
                ]
              ),
        ]),
      ]),
      _vm._v(" "),
      _c("el-col", { attrs: { xs: 0, sm: 6, md: 6, lg: 6, xl: 6 } }, [
        _vm._v(" "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }